// The backend puts the real failure reason in body.error and only a generic message in
// body.value.

const errorText = (error) => {
  if (typeof error === "string") return error.trim();
  if (error && typeof error === "object" && typeof error.message === "string") return error.message.trim();
  return "";
};

// Unconditional: use for payloads already known to be failures (an HTTP 4xx/5xx body).
export const normalizeApiErrorData = (data) => {
  const body = data?.body;
  if (body && typeof body === "object") {
    const message = errorText(body.error);
    if (message) body.value = message;
  }
  return data;
};

// For a response envelope returned to a caller: only touched when it is a failure,
// i.e. it has a header.code other than 600. Successful responses are never changed.
export const withApiError = (data) => {
  const code = data?.header?.code;
  if (code === undefined || code === null || Number(code) === 600) return data;
  return normalizeApiErrorData(data);
};

// For a caught axios error: callers read error.response.data.body.value, so make that the
// real message. Returns the same error object, ready to be re-thrown.
export const withApiErrorResponse = (error) => {
  normalizeApiErrorData(error?.response?.data);
  return error;
};

// Message for a failed envelope/error payload: body.error, then body.value, then fallback.
export const apiErrorMessage = (data, fallback = "") => {
  const body = data?.body;
  return errorText(body?.error) || errorText(body?.value) || fallback;
};
